import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-site grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-medium tracking-[0.2em] text-primary-600">FAQ</p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            用户常见问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于更新频率、内容来源与热榜机制，这里集中回答读者问得最多的几个问题。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="lg:col-span-8">
          <dl className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 text-lg transition-transform ${
                          isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}